export default __webpack_public_path__ + "static/spiritual-india-journey-4-9336c0b46d9978d12cb5e05fe74564df.jpg";